// src/routes/ProtectedRoute.jsx
// -----------------------------------------------------------------------------
// Wrap any page element with <ProtectedRoute> in App.jsx to require login.
// Optionally pass allowedRoles={['Admin', 'Project Manager']} to restrict a
// page to specific Login.Role values.
//
// FIX: this used to read localStorage.getItem('token') / ('user') directly -
// those keys were never written by AuthContext (which stores under
// 'afix_access_token' / 'afix_user'), so this ALWAYS bounced the user back
// to /login even after a 100% successful sign-in. It now reads from the
// AuthContext (useAuth()) instead, which is the single source of truth and
// also waits for the initial "restore session from storage" check to finish
// before deciding to redirect (avoids a flash-redirect on page refresh).
// -----------------------------------------------------------------------------
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/common/Loader';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  // Still checking localStorage for an existing session on first load -
  // don't redirect yet, or a logged-in user gets bounced on every refresh.
  if (loading) {
    return <Loader label="Checking session..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.roleName)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}